import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import ReactHtmlParser from 'react-html-parser'
import Section from '../common/Section'
import IframeResizer from 'iframe-resizer-react'

import useSSR from 'use-ssr'
import styled, { css } from 'styled-components'
import { rem } from 'polished'
import { get } from 'lodash'

// Extract iframe src
export function transform(node) {
  const { type, name } = node
  if (type === 'tag' && name === 'iframe') return node.attribs.src
}

// Extract script src/type from a string
function extractScriptAttributes(scriptString) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(scriptString, 'text/html')
  const scriptTag = doc.querySelector('script')
  if (!scriptTag) return null

  return {
    src: scriptTag.getAttribute('src'),
    type: scriptTag.getAttribute('type') || 'text/javascript',
  }
}

const EmbedModule = ({ primary: data }) => {
  const { isBrowser } = useSSR()
  const iframeRef = useRef()
  const body = get(data, 'embed_body.html') || ''
  const bgColor = get(data, 'background_color') || 'transparent'
  const src = get(ReactHtmlParser(body, { transform }), '[0].props.children[0]')
  const [messageData, setMessageData] = useState()

  // Detect and inject script embed on mount (client only)
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (body.includes('<script')) {
      const attrs = extractScriptAttributes(body)
      if (!attrs) return

      const script = document.createElement('script')
      script.src = attrs.src
      script.type = attrs.type
      script.async = true

      const target = document.getElementById('embed-script-container')
      if (target) {
        target.innerHTML = '' // Clear old content if any
        target.appendChild(script)
      }
    }
  }, [body])

  const onResized = data => {
    console.log('iframe resized', data)
    setMessageData(data)
  }

  const onMessage = data => {
    console.log('iframe message', data)
    setMessageData(data)
    iframeRef.current?.sendMessage('Hello back from the parent page')
  }

  return body ? (
    <Section id="embed-module" bgColor={bgColor} style={{ marginTop: '100px' }}>
      <Container>
        {!!isBrowser && body.includes('<iframe') && (
          <IframeResizer
            forwardRef={iframeRef}
            autoResize
            sizeHeight
            heightCalculationMethod="lowestElement"
            minHeight={640}
            src={src}
            onMessage={onMessage}
            onResized={onResized}
            style={{
              width: '100%',
              overflow: 'visible',
            }}
          />
        )}
        {!!isBrowser && body.includes('<script') && (
          <div id="embed-script-container" />
        )}
      </Container>
    </Section>
  ) : null
}

EmbedModule.propTypes = {
  primary: PropTypes.object,
}

export default EmbedModule

const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    min-height: ${rem(140)};
    max-width: ${theme.layout.maxWidth};
    margin: 0;

    div {
      width: 100%;
      -webkit-overflow-scrolling: touch;
      overflow: scroll;

      > * {
        -webkit-overflow-scrolling: touch;
        overflow: scroll;
      }
    }

    > div,
    iframe {
      width: 100%;
    }

    #embed-script-container iframe {
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }
  `}
`
